import React, { useEffect, useState } from "react";
import styles from "./SearchBar.module.css";
import { Link } from 'react-router-dom';
import { checkImageURL } from "../../utils/validations"; // Ensure this function is correctly imported
import image_not_found from "../../assets/image_not_found.png"; // Ensure this path is correct
import { getImageSrc } from "utils/imageUtils";
import ClientService from "services/ClientService";

// Accept medicaments and setSelectedProduct as props
// Modify to only render the suggestions list
export const SearchBar = ({ searchTerm, setSearchTerm, medicaments, setSelectedProduct, forceShowDropdown }) => {

  const handleSuggestionClick = (medicament) => {
    setSelectedProduct(medicament);
    // Do NOT clear search term after selecting a product
    // if (!forceShowDropdown) {
    //   setSearchTerm("");
    // }
  };

  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const results = await ClientService.searchProducts({
          q: searchTerm,
          min_price: 0,
          max_price: 1000,
          skip: 0,
          limit: 10,
        });
        setProducts(results);
      } catch (error) {
        console.error("Failed to fetch products:", error);
      }
    };

    if (searchTerm.length > 0) {
      fetchProducts();
    } else {
      setProducts([]);
    }
  }, [searchTerm]);

  // Filter medicaments based on searchTerm
  // Show all products if searchTerm is empty
  const suggestions = searchTerm
    ? products.filter(medicament =>
      medicament.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    : products;

  // Show suggestions if searchTerm, forceShowDropdown, or box is empty and there are products
  const shouldShowSuggestions = (searchTerm && suggestions.length > 0) || forceShowDropdown || (!searchTerm && products.length > 0);
  console.log("medicaments", products);

  const [validImage, setValidImage] = React.useState(true);
  return (
    <>
      {shouldShowSuggestions && (
        <ul className={styles.suggestionsList}>
          {(searchTerm ? suggestions : products).map(medicament => (
            <li key={medicament.id} onClick={() => handleSuggestionClick(medicament)} className={styles.suggestionItem}>
              <div className={styles.suggestionRow}>
                <img
                  // Unified image selection logic (like ProductCard)
                  src={(function () {
                    let src = image_not_found;
                    const imgData = medicament.imageData;
                    const img = medicament.image;
                    const imgUrl = medicament.image_url;
                    if (typeof imgData === 'string' && imgData.startsWith('data:image/')) {
                      const base64Data = imgData.split(',')[1] || '';
                      if (base64Data.length > 100) {
                        src = imgData;
                      } else {
                        console.warn('[SearchBar][BASE64] Too short or empty for', medicament.id, medicament.name, 'length:', base64Data.length);
                      }
                    } else if (typeof imgData === 'string' && (imgData.startsWith('http') || imgData.startsWith('/'))) {
                      src = imgData;
                    } else if (typeof img === 'string' && img.startsWith('data:image/')) {
                      const base64Data = img.split(',')[1] || '';
                      if (base64Data.length > 100) {
                        src = img;
                      } else {
                        console.warn('[SearchBar][BASE64] Too short or empty for', medicament.id, medicament.name, 'length:', base64Data.length);
                      }
                    } else if (typeof img === 'string' && (img.startsWith('http') || img.startsWith('/'))) {
                      src = img;
                    } else if (typeof imgUrl === 'string' && (imgUrl.startsWith('http') || imgUrl.startsWith('/'))) {
                      src = imgUrl;
                    }
                    return src;
                  })()}
                  alt={medicament.name}
                  className={styles.suggestionImage}
                  style={{ width: 54, height: 54, objectFit: 'contain', borderRadius: 10, marginRight: 12 }}
                  onError={(e) => {
                    e.currentTarget.onerror = null; // Prevents infinite loop if fallback image also errors
                    e.currentTarget.src = image_not_found;
                  }}
                />

                <span className={styles.suggestionName} style={{ flex: 1, textAlign: 'left', fontWeight: 500, fontSize: 16, color: '#222' }}>
                  {medicament.name}
                </span>
                <span className={styles.suggestionPrice} style={{ minWidth: 80, textAlign: 'right', fontWeight: 600, color: '#0E4736', fontSize: 15 }}>
                  {medicament.price ? `${medicament.price} TND` : '—'}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};
